import React, { FC } from 'react';
import FloatingMenuLink from '../floatingMenuLink';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TProductFloatingMenuContactUsItem } from '../../types/productFloatingMenu.types';
import SharedGenericPopUp from '../../../@shared/sharedGenericPopUp';

const ContactUsLink: FC<{ contactUsItem: Partial<TProductFloatingMenuContactUsItem>; rendering?: ComponentRendering }> = (props) => {
  const { id, fields } = props.contactUsItem || {};
  const popupProps = { rendering: props?.rendering, extraClassName: 'floating-links__contactUs' };

  return (
    <SharedGenericPopUp {...(popupProps as any)}>
      <FloatingMenuLink key={id} itemId={id} title={fields?.title} icon={fields?.icon} />
    </SharedGenericPopUp>
  );
};

export default ContactUsLink;
